export const setAnnouncmentAction = (announcment:any)=>
  ({
    type: 'SET_ANNOUNCMENT',
    payload: announcment,
  });
